<template>
    <div>
      <p>传统医学与替代医学的结合，即：根据每个人的发展趋势，安全有效地治愈、减轻或消除症状和预防疾病。</p>
      <p>“综合医学是以治疗为目的的医学，它考虑到整个人（身体、心灵和精神），包括人的各个方面。它强调治疗关系，并利用所有适当的疗法，包括传统疗法和替代疗法。”</p>
      <p>“综合医学”一词由美国国立卫生研究院的国家补充和替代医学中心定义，指出“综合医学结合了传统医学疗法和MAC疗法，并有一些最高质量的科学证据、安全和有效性”。</p>
    </div>
</template>

<script>
export default {
  name: 's1'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/s1.vue